
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.933 4.893l-1.826-1.826a1.333 1.333 0 00-1.774-.047l-6 6c-.215.217-.35.502-.38.807l-.286 2.78a.667.667 0 00.666.726h.06l2.78-.253c.305-.03.59-.165.807-.38l6-6a1.28 1.28 0 00-.047-1.807zm-6.88 6.854l-2 .186.18-2L8 6.213l1.8 1.8-3.747 3.734zm4.614-4.627L8.88 5.333 10.18 4 12 5.82l-1.333 1.3z"}})])
          )
        }
      }
    